import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cdcd548"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location_camera_list_wrap" }
const _hoisted_2 = { class: "spinner" }
const _hoisted_3 = { class: "map_location_button" }

import CameraItem from './CameraItem'
import CameraItemDetail from './CameraItemDetail'
import WhiteBox from '@/components/atoms/WhiteBox'
import SimpleButton from '@/components/atoms/SimpleButton'
import Spinner from '@/components/atoms/Spinner'
import { Camera } from '@/@types/typescript-axios'
import { computed, ref, watch, withDefaults } from 'vue'

type PropsType = {
  locationCameraList: { [key: string]: Camera } | null
  locationListShow: boolean
  isLoaded: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationCameraListMap',
  props: {
    locationCameraList: null,
    locationListShow: { type: Boolean, default: false },
    isLoaded: { type: Boolean, default: false }
  },
  emits: ["hideLocationCameraList", "setCameraLocation"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'hideLocationCameraList'): void
  (e: 'setCameraLocation', lat: number, lon: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { locationCameraList: { [key: string]: Camera } | null, locationListShow: boolean, isLoaded: boolean };



const cameraData = ref<Camera | {}>({})
const detailListShow = ref<boolean>(false)



const showDetailPage = (detailCameraData: Camera) => {
  cameraData.value = detailCameraData
  emit('setCameraLocation', detailCameraData.location_latitude, detailCameraData.location_longitude)
  detailListShow.value = true
}

const hideLocationCameraList = () => {
  emit('hideLocationCameraList')
  detailListShow.value = false
}

const locationName = computed<string>(() =>
  props.locationCameraList
    ? props.locationCameraList[Object.keys(props.locationCameraList)[0]].location_name
    : ''
)

const styleTop = computed<string>(() => (detailListShow.value ? '' : 'location_camera_list_top'))

const noCameraData = computed<boolean>(() => !props.locationCameraList && props.isLoaded)

watch(
  () => props.locationCameraList,
  (v) => {
    //  locationマーカーをクリックしてマップのdetailページに入ってカメラリストがない他のマーカーをクリックしたら残ってるので
    if (!v) {
      detailListShow.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["location_camera_list", _unref(styleTop)])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.locationCameraList, (camera, index) => {
        return _withDirectives((_openBlock(), _createBlock(_unref(CameraItem), {
          onShowDetailPage: showDetailPage,
          "camera-data": camera,
          key: index
        }, null, 8, ["camera-data"])), [
          [_vShow, !detailListShow.value]
        ])
      }), 128)),
      _withDirectives(_createVNode(_unref(CameraItemDetail), { "camera-data": cameraData.value }, null, 8, ["camera-data"]), [
        [_vShow, detailListShow.value]
      ])
    ], 2), [
      [_vShow, __props.isLoaded]
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_2, [
      _createVNode(_unref(Spinner), { size: "48px" })
    ], 512), [
      [_vShow, !__props.isLoaded]
    ]),
    _withDirectives(_createElementVNode("span", { class: "noCameraData" }, _toDisplayString(_ctx.$t('location_camera_list_map.no_related_camera')), 513), [
      [_vShow, _unref(noCameraData)]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(WhiteBox), {
        padding: 0,
        class: "location_name_wrap"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SimpleButton), {
            onClick: hideLocationCameraList,
            color: "color-dark3",
            size: "size-s",
            "icon-size": "40",
            class: "padding_zero",
            "use-border": false,
            icon: "keyboard_arrow_left"
          }),
          _withDirectives(_createElementVNode("div", { class: "location_name" }, _toDisplayString(_unref(locationName)), 513), [
            [_vShow, __props.isLoaded]
          ])
        ]),
        _: 1
      })
    ])
  ], 512)), [
    [_vShow, __props.locationListShow]
  ])
}
}

})